<template>
    <v-card v-if="!loading">
        <v-card-title>Cadastre registry / DAC7</v-card-title>
        <v-divider></v-divider>
        <v-row no-gutters class="px-2">
            <v-col class="pr-4" cols="6">
                <v-text-field v-model="huisProp1.huis_kadaster" label="Cadastre registry"></v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters class="px-2">
            <v-col cols="3" class="pr-4">
                <v-select v-model="huisProp1.huis_dac7" :disabled="!huisProp1.huis_dac7Allowed" :items="huisProp1.huis_dac7Keuzes" item-value="code" item-text="desc" label="DAC7"></v-select>
            </v-col>
        </v-row>  
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary mx-2" small @click="updHuisProp1">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        props: {
            huis_encrid: {
                type: String,
                required: true
            }
        },
        data() { 
            return {
                loading: true,
                // huis_dac7Keuzes: [],
                huisProp1: {}
            }
        },
        mounted() {
            this.getHuisProp1();
        },
        methods: {
            getHuisProp1() {
                this.$axios.post("ares/json/ares/huis/getHuisProp1.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisProp1"
                    },
                    getHuisProp1: {
                        huis_encrid: this.huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.huisProp1 = res.data.getHuisProp1;
                        // this.huis_dac7Keuzes = res.data.huisProp1.huis_dac7Keuzes;
                        this.loading = false;
                    }
                });
            },
            updHuisProp1() { 
                this.$axios.post("ares/json/ares/huis/updHuisProp1.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHuisProp1"
                    },
                    updHuisProp1: this.huisProp1,
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else { 
                        //this.$router.reload('/huis/onHuis/' + res.data.updHspl.huis_encrid);        
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.updHuisProp1.text,
                            color: res.data.updHuisProp1.color
                        }); 
                    }
                })
            },
        }
    }
</script>
